import PropTypes from 'prop-types';
import React from 'react';
import styles from './style.css';

class CustomerInfo extends React.Component {
  render() {
    const { customerDetail } = this.props;

    return (
      customerDetail && (
        <div className="customer-info-box">
          <div className={`header ${styles['header-name']}`}>
            {customerDetail.name ||
              customerDetail.email ||
              customerDetail.phone}
          </div>
          <div className="info-profile">
            <table>
              <tbody className={styles['no-hover']}>
                <tr>
                  <td className="text-left">Address</td>
                  <td
                    className={`text-left wrap-customer-address ${styles.address}`}
                  >
                    {customerDetail.address}
                  </td>
                </tr>
                <tr>
                  <td className="text-left">Phone</td>
                  <td className="text-left">{customerDetail.phone}</td>
                </tr>
                <tr>
                  <td className="text-left">Email</td>
                  <td className={`text-left ${styles.email}`}>
                    {customerDetail.email}
                  </td>
                </tr>
                <tr>
                  <td className="text-left">Birthday</td>
                  <td className="text-left">{customerDetail.birthday}</td>
                </tr>
                <tr>
                  <td className="text-left">Gender</td>
                  <td className="text-left">{customerDetail.sex}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  }
}

CustomerInfo.propTypes = {
  customerDetail: PropTypes.object,
};

export default CustomerInfo;
